import { render, staticRenderFns } from "./SVGIcon.vue?vue&type=template&id=34f9f2fe&"
import script from "./SVGIcon.vue?vue&type=script&lang=ts&"
export * from "./SVGIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports